var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.383 0 0 5.417 0 12.076 0 18.117 4.436 23.122 10.2 24v-8.905H7.8c-.331 0-.6-.27-.6-.604v-1.812c0-.334.269-.603.6-.603h2.4V9.883c0-2.869 1.456-4.449 4.1-4.449 1.072 0 1.917.075 1.953.078.31.028.547.289.547.601v2.038a.6.6 0 0 1-.6.604H15c-.662 0-1.2.541-1.2 1.207v2.114h2.4c.172 0 .336.074.45.204s.167.303.146.474l-.225 1.812a.6.6 0 0 1-.596.528H13.8V24c5.764-.878 10.2-5.883 10.2-11.924C24 5.417 18.617 0 12 0"
  })));
};
export { SvgFacebook as ReactComponent };